import type { CSSProperties } from "react";
import { Mic, Plus } from "lucide-react";
import { cn } from "@/lib/utils";

export const WA_MOCK = {
  chatBg: "#E5DDD5",
  outgoing: "#D9FDD3",
  incoming: "#FFFFFF",
  text: "#111B21",
  tick: "#53BDEB",
  inputBar: "#F0F2F5",
  header: "#008069",
} as const;

/** Padrão sutil de fundo do chat (estilo WhatsApp) */
export const waChatBackgroundStyle: CSSProperties = {
  backgroundColor: WA_MOCK.chatBg,
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M0 0h8v8H0z' fill='%23e5ddd5'/%3E%3Cpath d='M1 1h2v2H1zM5 5h2v2H5z' fill='%23d6d0c4' fill-opacity='.45'/%3E%3C/svg%3E")`,
};

export function WhatsAppMockDatePill({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "rounded-lg bg-white/95 px-2.5 py-0.5 text-[9px] font-medium text-[#54656f] shadow-sm",
        className,
      )}
    >
      Hoje
    </span>
  );
}

export function WhatsAppMockInputBar({ className }: { className?: string }) {
  return (
    <footer
      className={cn("shrink-0 border-t border-black/[0.06] px-1.5 py-1.5", className)}
      style={{ backgroundColor: WA_MOCK.inputBar }}
      aria-hidden
    >
      <div className="flex items-end gap-1">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center text-[#54656f]">
          <Plus className="h-5 w-5" strokeWidth={1.75} />
        </div>
        <div className="flex min-h-[36px] flex-1 items-center rounded-full bg-white px-3 py-2 shadow-sm">
          <span className="text-[11px] text-[#667781]">Mensagem</span>
        </div>
        <div
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-white"
          style={{ backgroundColor: WA_MOCK.header }}
        >
          <Mic className="h-[18px] w-[18px]" strokeWidth={2} />
        </div>
      </div>
    </footer>
  );
}
